import { generateKeyBetween } from 'fractional-indexing';

/**
 * User-ordered rows (groups, tasks) carry a fractional-index `position` (data model §1): moving an item
 * rewrites only that item. The API stores the keys; the web app uses the same function to place an
 * item optimistically before the server answers.
 *
 * Keys compare by UTF-16 code unit — that is JavaScript's `<` and PostgreSQL's `COLLATE "C"`
 * (migration 0004). Never compare them with `localeCompare`.
 */
export function positionBetween(before: string | null, after: string | null): string {
  return generateKeyBetween(before, after);
}

/** Sort comparator for positions (code-unit order). */
export function comparePositions(a: string, b: string): number {
  if (a === b) return 0;
  return a < b ? -1 : 1;
}
